"use server"
import bcrypt from 'bcrypt';
import { pool } from './database';
import {genApiKey} from "@/api/utils/generator";

const SALT_ROUNDS = 12;

async function hashPassword(plain: string): Promise<string> {
    return await bcrypt.hash(plain, SALT_ROUNDS);
}

async function verifyPassword(plain: string, hash: string): Promise<boolean> {
    return await bcrypt.compare(plain, hash);
}

export async function register(email: string, pass: string, username: string, role_id: number, szakma_id: string | null){
  const hashedPassword = await hashPassword(pass);
  const apiKey = genApiKey();
  await pool.query("SET FOREIGN_KEY_CHECKS = 0");
  await pool.query(`INSERT INTO \`felhasznalok\` (email, psw, username, role_id, api_key, szakma_id) VALUES(?, ?, ?, ?, ?, ?)`, [email, hashedPassword, username, role_id, apiKey, Number(szakma_id) ?? null]);
  await pool.query("SET FOREIGN_KEY_CHECKS = 1");
}

export async function loginVal(email: string, pass: string): Promise<returnDataForLogin>{
    const [rows] = await pool.query(`SELECT * FROM \`felhasznalok\` WHERE email = ?`, [email]);

    if (!rows || (rows as userData[]).length === 0) {
        console.log("User not found");
        return {
            success: false
        };
    }

    const user = (rows as userData[])[0];

    const verify = await verifyPassword(pass, user.psw.trim());
    if(!verify){
        return {
            success: false
        };
    }

    return {
        success: true,
        role_id: user.role_id,
        api_key: user.api_key
    };
}
interface userData {
    user_id: number;
    email: string;
    psw: string;
    username: string;
    role_id: number;
    api_key?: string;
    szakma_id: string | null;
}

interface returnDataForLogin {
    success: boolean;
    role_id?: number;
    api_key?: string;
}